import {ColDef, ICellRendererParams} from "ag-grid-community";
import {t} from "i18next";
import React, {ReactNode} from "react";
import {dateFormatter} from "../../utils";
import {LocationDiscountEntityResponse} from "./Types/locationDiscount";

export const locationDiscountColDef = ({
                                           actionsRenderer,
                                           actionColDef,
                                           user
                                       }: {
    actionsRenderer: (params: ICellRendererParams) => ReactNode;
    actionColDef: ColDef
    user: any
}): ColDef<LocationDiscountEntityResponse>[] => [
    {
        field: "legalEntities",
        headerName: t("pricing:peaks.table.headers.legalEntities"),
        headerTooltip: t("pricing:upsellingRate.table.headers.legalEntities"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:legalEntities.'.concat(params.data.legalEntity)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        field: "dealers",
        headerName: t("pricing:peaks.table.headers.dealers"),
        headerTooltip: t("pricing:upsellingRate.table.headers.dealers"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:dealers.'.concat(params.data.dealer)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        headerName: "Location",
        headerTooltip: "Location",
        field: "locationCodes",
        cellRenderer: (params: ICellRendererParams) => params.data.prcLocation.name,
        sortable: true,
        flex: 1,
        filter: "text",
    },
    {
        headerName: "Profili",
        headerTooltip: "Profili",
        field: "lppProfileIds",
        cellRenderer: (params: ICellRendererParams) => params.data.lppProfile.name,
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        headerName: "Discount",
        headerTooltip: "Discount",
        field: "discounts",
        cellRenderer: (params: ICellRendererParams) => params.data.discount + "%",
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        headerName: t("pricing:ancillary.form.labels.reservationFrom"),
        headerTooltip: t("pricing:ancillary.form.labels.reservationFrom"),
        field: "validityFrom",
        valueFormatter: (params) =>
            params.data?.validityDateFrom ? dateFormatter(params.data?.validityDateFrom) : "",
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        headerName: t("pricing:ancillary.form.labels.reservationTo"),
        headerTooltip: t("pricing:ancillary.form.labels.reservationTo"),
        field: "validityTo",
        valueFormatter: (params) =>
            params.data?.validityDateTo ? dateFormatter(params.data?.validityDateTo) : "",
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        field: "pickUpDateFrom",
        headerName: t("pricing:ancillary.form.labels.pickupDateFrom"),
        headerTooltip: t("pricing:ancillary.form.labels.pickupDateFrom"),
        flex: 1,
        valueFormatter: (params: any) => params.data.pickUpDateFrom ? dateFormatter(params.data.pickUpDateFrom) : "",
        filter: "text"
    },
    {
        field: "pickUpDateTo",
        headerName: t("pricing:ancillary.form.labels.pickupDateTo"),
        headerTooltip: t("pricing:ancillary.form.labels.pickupDateTo"),
        flex: 1,
        valueFormatter: (params: any) => params.data.pickUpDateTo ? dateFormatter(params.data.pickUpDateTo) : "",
        filter: "text"
    },
    {
        ...actionColDef,
        cellRenderer: actionsRenderer,
    },
];
